import { request } from "../../api/api";

export const getSmartTagGateway = (params) => {
  return request.post(`/smarttag/overview/getGateway/`, params);
};

export const getSmartTagMachine = (params) => {
  return request.post(`/smarttag/overview/getMachine/`, params);
};

export const getAnalyticsGraphDataCOC = (params) => {
  return request.post(`/vms/reports/getAnalyticsGraphData/`, params);
};
export const getPiechartCOC = (params) => {
  return request.post(`/vms/reports/getAnalyticsPieChartData/`, params);
};

export const getDeviceByDashboard = (params) => {
  return request.post(`/dashboard/getDeviceByDashboard/`, params);
};

export const getTagList = (params) => {
  return request.post(`/vms/reports/getTagList/`, params);
};

export const getTagDevice = (params) => {
  return request.post(`/smarttag/overview/getDevice/`, params);
};

export const getTagGroups = (params) => {
  return request.post(`/smarttag/overview/getTagsGroups/`, params);
};
export const getTagsOfDeviceAlarmStatus = (params) => {
  return request.post(`/smarttag/overview/getTagsOfDeviceAlarmStatus/`, params);
};

export const getInteractionTag = (params) => {
  return request.post(`/smarttag/getInteractedTag/`, params);
};

export const getTagData = (params) => {
  return request.post(`/smarttag/getTagData/`, params);
};

export const publistData = (params) => {
  return request.post(`/smarttag/addTagPublishHistory/`, params);
};

export const tagInteractionData = (params) => {
  return request.post(`/smarttag/tagInteraction/`, params);
};

export const pinUnpinGroupData = (params) => {
  return request.post(`/smarttag/overview/pinUnpinGroup/`, params);
};
export const getTagBarGraphData = (params) => {
  return request.post(`/smarttag/getTagBarGraph/`, params);
};

export const getAlarmStatus = (params) => {
  return request.post(`/smarttag/overview/getGatewayAlarmStatus/`, params);
};

export const getMachineAlarmStatus = (params) => {
  return request.post(`/smarttag/overview/getMachineAlarmStatus/`, params);
};

export const getDeviceAlarmStatus = (params) => {
  return request.post(`/smarttag/overview/getDeviceAlarmStatus/`, params);
};

export const exportSmartTagAnalyticsCOC = (params) => {
  return request.post(`/smarttag/exportSmartTagAnalyticsCOCExcel/`, params);
};
export const exportSmartTagAnalyticsPOP = (params) => {
  return request.post(`/smarttag/exportSmartTagAnalyticsPOPExcel/`, params);
};
export const exportSmartTagReportsExcel = (params) => {
  return request.post(`/smarttag/exportSmartTagReportsExcel/`, params);
};

export const exportSmarTagLiveExcel = (params) => {
  return request.post(`/smarttag/exportSmarTagLiveReportExcel/`, params);
};
export const smartTagPlantDashboardCount = (params) => {
  return request.post(`/smarttag/countForSmartTagPlantDashboard/`, params);
};
export const SmartTagPlantDashboardView = (param) => {
  return request.post("/smarttag/SmartTagPlantDashboardView/", param);
};
export const getSmartTagDashboardView = (id) => {
  return request.get(`/smarttag/getSmartTagDashboardView/?company_id=${id}`);
};

export const getDeviceTagByTypeForSmartTag = (data) => {
  return request.post(
    "/dashboard/getSmarttagDashboardDeviceTagListforType/",
    data
  );
};

export const getIChartReportDetails = (params) => {
  return request.post("/smarttag/getIChartReportDetails/", params);
};

export const getTopBarTagDetails = (params) => {
  return request.post("/smarttag/getTopBarTagDetails/", params);
};

export const getMRChartReportDetails = (params) => {
  return request.post("/smarttag/getMRChartReportDetails/", params);
};

export const getSPCDashboardSideBarDetails = (params) => {
  return request.post("/smarttag/getSPCDashboardSideBarDetails/", params);
};

export const getAnalyticsIChartDetail = (params) => {
  return request.post("/smarttag/getAnalyticsIChartDetail/", params);
};

export const getAnalyticsMRChartDetail = (params) => {
  return request.post("/smarttag/getAnalyticsMRChartDetail/", params);
};

export const getSPCReportTableDetails = (params) => {
  return request.post("/smarttag/getSPCReportTableDetails/", params);
};

export const exportSPCReportsExcel = (params) => {
  return request.post("/smarttag/exportSPCReportsExcel/", params);
};

export const exportSPCAnalyticsExcel = (params) => {
  return request.post("/smarttag/exportSPCAnalyticsExcel/", params);
};